import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = [
  {
    path: '/internal/health/basic',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "basic_health_check" */ 'site-modules/health-check/pages/basic/basic')
    ),
    chunkName: 'basic_health_check',
    inlineCritical: false,
  },
  {
    path: '/v/healthcheck',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "basic_health_check" */ 'site-modules/health-check/pages/basic/basic')
    ),
    chunkName: 'basic_health_check',
    inlineCritical: false,
  },
];
